import React, { useEffect, useState } from 'react';
import PredictionTrendsPage from '../Analysis_A/PredictionTrendsPage';
import TopicsTrendsPage from '../Analysis_A/TopicsTrendsPage';
import TopicsIntensityAnalysis from '../Analysis_A/Topics_Intensity_Analysis';
import PageTabs from '../components/PageTabs';
import './Pages.scss';
import { topicsTrendsStore, TOPICS_THEMES } from '../Analysis_A/TopicsTrendsStore';
import { PAGE_KEYS } from '../utils/pageAccess';

function TopicsAnalysis({ allowedPages = [] }) {
  const [activeTab, setActiveTab] = useState('tgs');

  const tabs = [
    { id: 'tgs', label: 'Анализ по ТГС', page: PAGE_KEYS.THEMATIC },
    { id: 'neuro', label: 'Нейросетевой анализ', page: PAGE_KEYS.THEMATIC },
    { id: 'user', label: 'Пользовательская классификация', page: PAGE_KEYS.TOPIC_INTENSITY }
  ];

  const filteredTabs = tabs.filter((tab) => allowedPages.includes(tab.page));
  const canRenderActiveTab = filteredTabs.some((tab) => tab.id === activeTab);
  const firstAllowedTabId = filteredTabs[0]?.id;

  useEffect(() => {
    if (firstAllowedTabId && !canRenderActiveTab) {
      setActiveTab(firstAllowedTabId);
    }
  }, [canRenderActiveTab, firstAllowedTabId]);

  return filteredTabs.length > 0 ? (
    <div className="top-level-page-container">
      <PageTabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={filteredTabs} />
      <div className='page-content'>
        {canRenderActiveTab && activeTab === 'tgs' && (
          <TopicsTrendsPage store={topicsTrendsStore} themes={TOPICS_THEMES}  />
        )}
        {canRenderActiveTab && activeTab === 'neuro' && (
          <PredictionTrendsPage />
        )}
        {canRenderActiveTab && activeTab === 'user' && (
          <TopicsIntensityAnalysis />
        )}
      </div>
    </div>
  ) : (
    <div className="top-level-page-container">
      <h1>У вас нет доступа к этой странице</h1>
    </div>
  );
}

export default TopicsAnalysis;
